import React, { useState } from "react";
import "./TracerMain.css";
import { Container } from "react-bootstrap";
import TracerProgress from "../../Component/Sidebar/TracerProgress";
import Run from "../../images/run.png";
import Skip from "../../images/skip.png";
import noted from "../../images/notepad.png";
import checklist from "../../images/checklist.png";
import repair from "../../images/repair.png";
import TracerSearch from "../../Component/Sidebar/TracerInput";
import TracerCard from "../TracerCards/TracerCard";
import Model from "../../Component/Pop/Model";
import Pagination from "../../Component/pagination/Pagination";
import ModelTest from "../../Component/Pop/ModelTest";
import TracerSidebar from "../../Component/Sidebar/TracerSidebar";
import TracerNavbar from "../../Component/Navbar/TracerNavbar";
import Footer from "../../Component/Footer/Footer";
import ModelTracer from "../../Component/Pop/ModelTracer";
import ModelHistory from "../../Component/Pop/ModelHistory";

const TracerMainHeader = () => {
  const [openModel, setOpenModel] = useState(false);
  const [openModelTest, setOpenModelTest] = useState(false);
  const [openModelTracer, setOpenModelTracer] = useState(false);
  const [openModelHistory, setOpenModelHistory] = useState(false);
  const [isActive, setActive] = useState(false);
  const [selected, setSelected] = useState("RF TEST");
  
  const toggleClass = () => {
    setActive(!isActive);
  };
  return (
    <>
    
      <div className="App">
        <div className="side-bar ">
          <TracerSidebar handleClick={toggleClass} isActive={isActive}/>
        </div>
        <div className="main w-100">
          <TracerNavbar isActive={isActive} />
          <Container>
            <div className="head-select">
              <TracerProgress done={30} />
              <div className="top-bar tob-bar2">
                <div className="top-icons">
                  <div className="top-icon-btn" onClick={() => {
                      setOpenModelTracer(true);
                    }}>
                    <a>
                      <img src={Run} alt="run" /> Run
                    </a>{" "}
                  </div>
                  <div className="top-icon-btn">
                    <a>
                      <img src={Skip} alt="run" /> Skip
                    </a>{" "}
                  </div>
                  <div
                    className="top-icon-btn"
                    onClick={() => {
                      setOpenModelTest(true);
                    }}
                  >
                    <a>
                      <img src={checklist} alt="run" /> Test Results
                    </a>{" "}
                  </div>
                  <div
                    className="top-icon-btn"
                    onClick={() => {
                      setOpenModel(true);
                    }}
                  >
                    <a>
                      <img src={repair} alt="run" /> Repair Action
                    </a>{" "}
                  </div>
                  <div className="top-icon-btn"  onClick={() => {
                      setOpenModelHistory(true);
                    }}>
                    <a>
                      <img src={noted} alt="run" /> Repair History
                    </a>{" "}
                  </div>
                </div>
                <TracerSearch  selected={selected} setSelected={setSelected}/>
              </div>
              <div className="main-select">
                <div className="tracer-card-main">
                  <div className="cards">
                    <TracerCard />
                  </div>
                  <div className="chat-label">
                    <ul className="chat-list">
                      <li className="chat-items">
                        <div className="chat-point">102 / 0</div>
                        <div className="chat-lab">Panels / Hour</div>
                      </li>
                      <li className="chat-items">
                        <div className="chat-point">55 / 43%</div>
                        <div className="chat-lab">Yield Rate</div>
                      </li>
                      <li className="chat-items">
                        <div className="chat-point">102 / 0</div>
                        <div className="chat-lab">Panels / Hour</div>
                      </li>
                      <li className="chat-items">
                        <div className="chat-point">55 / 43%</div>
                        <div className="chat-lab">Yield Rate</div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <Pagination />
            </div>
          </Container>
          <Footer />
        </div>
      </div>
      {openModel && <Model closeModel={setOpenModel} />}
      {openModelTest && <ModelTest closeModelTest={setOpenModelTest} />}
      {openModelTracer && <ModelTracer closeModelTracer={setOpenModelTracer} />}
      {openModelHistory && <ModelHistory closeModelHistory={setOpenModelHistory} />}
    </>
  );
};

export default TracerMainHeader;
